export default class Waypoints {
  constructor() {
    this.$links = document.querySelectorAll("[data-waypoint]");
    console.log("this.$links ", this.$links);
    this.$header = document.querySelector(".c-header");
    this.onClick = this.constructor.onClick.bind(this);
    this.$links.forEach((link) => this.setupLink(link));
  }

  setupLink(link) {
    link.addEventListener("click", this.constructor.onClick);
  }

  static onClick(e) {
    e.preventDefault();

    const element = document.getElementById(e.currentTarget.dataset.waypoint);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
}
